// removed by extract-text-webpack-plugin
module.exports = {"BurgerMenu":"Burger-Menu__BurgerMenu--2etK-","menu__toggle":"Burger-Menu__menu__toggle--26PXk","menu__btn":"Burger-Menu__menu__btn--30VwW","menu__box":"Burger-Menu__menu__box--1NiY7","menu__item":"Burger-Menu__menu__item--1_Me_"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Menu/Burger-Menu.css
// module id = 73
// module chunks = 0